import { Component, Input } from '@angular/core';


@Component({
  selector: 'cgp-panel',
  templateUrl: './cgp-panel.component.html',
  styleUrls: ['./cgp-panel.component.scss']
})
export class CgpPanelComponent {

  constructor() { }

  @Input() title: string = undefined;
  @Input() imageClass: string = undefined;
  @Input() iconClass: string = undefined;
  @Input() color: string = undefined;
  @Input() description: string = undefined;
  @Input() admin: boolean;
  @Input() url: string = undefined;

  onClick = () => {
    if (this.url) {
      window.open(this.url, '_self');
    }
  }
}
